import './index.scss';
import Sidebar from '../Sidebar';
import { Outlet } from 'react-router-dom';

const Layout = () => {
  return (
  <div className='App'>
    <Sidebar />
    <div className='page'>
      <Outlet />
      <span className='bottom-tag-html'>&lt;/html&gt;</span>
    </div>
  </div>
  )
};

export default Layout;